<template>
  <div
    id="section-practice"
    class="text--text"
    data-qa="section_practice"
  >
    <PreviewPractice @click:show-more="handleClickShowMore" />

    <CoreBottomSheet
      v-model="isVisibleBottomSheet"
      eager
      slot-content-class="gr-6"
    >
      <IntroductionContent
        variant="drawer"
        class="mb-2"
      />
      <DiseasesStatistics class="mb-2" />
      <PatientStatistics class="mb-2" />
      <LpuListPartners class="mb-2" />
      <PracticeUpdatedDate />

      <template #actions>
        <div class="w-100">
          <v-btn
            block
            depressed
            large
            color="bg-primary"
            class="primary--text text-subtitle-1 rounded-lg"
            data-qa="section_practice_close"
            @click="isVisibleBottomSheet = false"
          >
            Закрыть
          </v-btn>
        </div>
      </template>
    </CoreBottomSheet>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue'
import useYandexGoals from 'src/composables/useYandexGoals'
import CoreBottomSheet from 'src/core/CoreBottomSheet/CoreBottomSheet.vue'
import PreviewPractice from 'src/components/pages/[town_translit]/vrach/[doctor_translit]/SectionPractice/mobile/PreviewPractice.vue'
import LpuListPartners from 'src/components/pages/[town_translit]/vrach/[doctor_translit]/SectionPractice/common/LpuListPartners.vue'
import PatientStatistics from 'src/components/pages/[town_translit]/vrach/[doctor_translit]/SectionPractice/common/PatientStatistics.vue'
import DiseasesStatistics from 'src/components/pages/[town_translit]/vrach/[doctor_translit]/SectionPractice/common/DiseasesStatistics.vue'
import IntroductionContent from 'src/components/pages/[town_translit]/vrach/[doctor_translit]/SectionPractice/common/IntroductionContent.vue'
import PracticeUpdatedDate from 'src/components/pages/[town_translit]/vrach/[doctor_translit]/SectionPractice/common/PracticeUpdatedDate.vue'

const { sendYaGoal } = useYandexGoals()

const isVisibleBottomSheet = ref(false)

function handleClickShowMore() {
  sendYaGoal('doctorPage__ShowMoreDoctorPractice')
  isVisibleBottomSheet.value = true
}
</script>
